import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@14.2.7_@babel+core@7.26.10_babel-plugin-macros@3.1.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["StyledSection","StyledTimeline","StyledEvent","StyledSectionTitle"] */ "/opt/build/repo/src/app/events/styles.ts");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/assets/images/wing.png");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/assets/svg/aef-lightmode-logo.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/assets/svg/aef-text-lightmode-logo.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/buttons/MinorButton/MinorButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/buttons/Outline/OutlineButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/buttons/SolidButton/SolidButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/cards/BookCardContent/BookCardContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StyledContentContainer","StyledMetaContainer"] */ "/opt/build/repo/src/components/cards/CardContent/styles.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/cards/CardGridContainer/styles.ts");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/components/cards/MediumCard/styles.ts");
;
import(/* webpackMode: "eager", webpackExports: ["StyledUpcomingEventCardContainer","StyledContentContainer","StyledPostCardImg"] */ "/opt/build/repo/src/components/cards/UpcomingEventCard/styles.ts");
;
import(/* webpackMode: "eager", webpackExports: ["StyledTextContainer","StyledTextHeading"] */ "/opt/build/repo/src/components/cards/UpcomingEventCard/TextContent/styles.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/images/DefaultThumbnailImage/DefaultThumbnailImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StyledFigure"] */ "/opt/build/repo/src/components/images/ImageContainer/styles.ts");
;
import(/* webpackMode: "eager", webpackExports: ["StyledLogoLarge","StyledLogoTextOnly","StyledLogoMedium"] */ "/opt/build/repo/src/components/images/Logo/styles.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/tags/MajorTag/MajorTag.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/tags/MinorTag/MinorTag.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StyledHeroHeading","StyledHeroHeadingContentHome","StyledHeroHeadingContent"] */ "/opt/build/repo/src/components/ui/HeroHeading/styles.ts");
;
import(/* webpackMode: "eager", webpackExports: ["StyledLayoutContainer"] */ "/opt/build/repo/src/components/ui/LayoutContainer/styles.ts");
